import { render, staticRenderFns } from "./CheckBoxService.vue?vue&type=template&id=3070cbf8"
import script from "./CheckBoxService.vue?vue&type=script&lang=js"
export * from "./CheckBoxService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports